module.exports = __webpack_public_path__ + "static/images/containers/StrongholdExternal/components/Statistics/images/elo-icon-10.c1f78890.png";


//////////////////
// WEBPACK FOOTER
// ./containers/StrongholdExternal/components/Statistics/images/elo-icon-10.png
// module id = 3448
// module chunks = 11